import { NavLink, useParams } from 'react-router-dom';

import { RegistrantFilter } from '@/types/registration.types';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import { TGlobalContainerDesigns } from '@styles/design-system/global-components/global-components.types';
import useGetDisplayProjectName from '@/utils/use-get-display-project-name';

import styles from '../passcode-lists/add-new-passcode-list-card.module.css';

type RegistrantFilterCardProps = {
  filter: RegistrantFilter;
};

const RegistrantFilterCard = ({ filter }: RegistrantFilterCardProps) => {
  const { projectUuid, language } = useParams();
  const projectName = useGetDisplayProjectName();

  return (
    <NavLink
      to={`/project/edit/${projectUuid}/${language}/audiences/registrants?status=${filter.type}`}
      className={styles['passcode-list-edit']}
      style={{ textDecoration: 'none' }}
    >
      <Container
        height="180px"
        width="320px"
        design={TGlobalContainerDesigns.GlobalCont1}
        className="padding-h-20 padding-b-20 flex fd-column jc-space-between radius-16"
      >
        <Container className="flex fd-column" height="125px">
          <Text tag="h5" clamp={5} className="H5 padding-t-20">
            {filter.name}
          </Text>
          <Text className="P2 padding-t-8" design="GlobalIcoText3">
            {projectName}
          </Text>
        </Container>
        <Container
          background="rgba(var(--primitives-mode-1-gray-1200-rgb), 0.2)"
          padding="8px 10px"
          className="flex fd-row jc-flex-end radius-8"
          style={{ lineHeight: '13px', alignSelf: 'flex-end' }}
        >
          <Icon name={ICONS.PEOPLE_NAV} size={13} color="var(--global-ico-text-2)" />
          <Text fontSize={'13px'} className="margin-l-4" design="GlobalIcoText2">
            {filter.member_count || '-'}
          </Text>
        </Container>
      </Container>
    </NavLink>
  );
};

export default RegistrantFilterCard;
